import { useEffect } from "react";
import React from "react";

const BoardOfDirectors = ({ directors, setDirectors, onSave,isBOD,getData,deleteById,swalAlert}) => {
  const handleEditClick = (id) => {
    setDirectors(
      directors.map((director) =>
        director.id === id ? { ...director, isEditing: !director.isEditing, newRecord : false } : director
      )
    );
  };


  const handleSave = (id) => {
    const directorToSave = directors.find((director) => director.id === id);
  
    if (!directorToSave.name.trim()) {
      swalAlert.Alert("The Name field is required. Please fill it out before proceeding.");
      return; 
    }
  
    const updatedDirectors = directors.map((director) =>
      director.id === id ? { ...director, isEditing: false } : director
    );
  
    setDirectors(updatedDirectors);
  
    const savedDirector = updatedDirectors.find((dir) => dir.id === id);
  
    if (typeof onSave === "function") {
      onSave(savedDirector);
    } else {
      console.error("onSave is not a function:", onSave);
    }
  
    getData();
  };
  

  const handleChange = (id, field, value) => {
    setDirectors(
      directors.map((director) =>
        director.id === id ? { ...director, [field]: value } : director
      )
    );
  };

  const handleAdd = () => {
    if (directors.length > 0) {
      const lastDirector = directors[directors.length - 1];
      if (!lastDirector.name.trim()) {
        swalAlert.Alert(`Please enter a Name before adding a ${isBOD ?'new Board of Director' : 'top Management' }.`);
        return; 
      }
    }
  
    const newId = directors.length ? directors[directors.length - 1].id + 1 : 1;
    setDirectors([
      ...directors,
      { id: newId, name: "", designation: "", isEditing: true, isBoardOfDirectors: isBOD },
    ]);
  };

  const handleDelete = (id) => {

    let director = directors.find((director) => director.id === id);
  
    let req = {
      id: director.directorManagementIndividualsID,
      deletedBy: 115,
      appId: 112
    };
  
    deleteById(req);
    setDirectors(directors.filter((director) => director.id !== id));
  };
  
  return (
    <div className="board-of-directors">
      <div className="add-btn-sec">
        <button type="button" className="btn btn-theme mb-4 txt underline flex" onClick={handleAdd}>
          + Add
        </button>
      </div>
      <div className="relative overflow-x-auto">
        <table className="custom-table editable-grid">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Designation</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {directors.map((director, index) => (
              <tr key={director.id}>
                <td>{index + 1}.</td>
                <td className={director.isEditing ? "input-edit" : ""}>
                  {director.isEditing ? (
                    <input
                      type="text"
                      value={director.name}
                      onChange={(e) => handleChange(director.id, "name", e.target.value)}
                    />
                  ) : (
                    director.name
                  )}
                </td>
                <td className={director.isEditing ? "input-edit" : ""}>
                  {director.isEditing ? (
                    <input
                      type="text"
                      value={director.designation}
                      onChange={(e) => handleChange(director.id, "designation", e.target.value)}
                    />
                  ) : (
                    director.designation
                  )}
                </td>
                <td>
                  <span className="flex items-center justify-center action-btn">
                    <button
                      className={`action-btn mr-4 flex items-center ${director.isEditing ? "hide-icon" : ""}`}
                      onClick={() => handleEditClick(director.id)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                        <path
                          fill="currentColor"
                          d="M20.094.25a2.25 2.25 0 0 0-1.625.656l-1 1.031l6.593 6.625l1-1.03a2.32 2.32 0 0 0 0-3.282L21.75.937A2.36 2.36 0 0 0 20.094.25m-3.75 2.594l-1.563 1.5l6.875 6.875L23.25 9.75zM13.78 5.438L2.97 16.155a.98.98 0 0 0-.5.625L.156 24.625a.975.975 0 0 0 1.219 1.219l7.844-2.313a.98.98 0 0 0 .781-.656l10.656-10.563l-1.468-1.468L8.25 21.813l-4.406 1.28l-.938-.937l1.344-4.593L15.094 6.75zm2.375 2.406l-10.968 11l1.593.343l.219 1.47l11-10.97z"
                        />
                      </svg>
                    </button>
                    {director.isEditing ? (
                      <button className="action-btn mr-4 flex items-center" onClick={() => handleDelete(director.id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <path
                            fill="currentColor"
                            d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
                          />
                        </svg>
                      </button>
                    ) : (
                      <button className="action-btn mr-4 flex items-center" onClick={() => handleDelete(director.id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <path
                            fill="currentColor"
                            d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
                          />
                        </svg>
                      </button>
                    )}
                    {director.isEditing && (
                      <button className="action-btn txt underline flex items-center" onClick={() => handleSave(director.id)}>
                        Save
                      </button>
                    )}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BoardOfDirectors;
